export enum AudioEvents {
  PLAY = 'pp-play-sound',
  PAUSE = 'pp-pause-sound',
  STOP = 'pp-stop-sound',
}

export interface AudioEventPlayDetailType {
  name: string;
  channel: string;
  loop?: boolean;
  start?: number;
  delay?: number;
  duration?: number;
}

export interface AudioEventStopDetailType {
  name: string;
}

export interface SoundResourceType {
  name: string;
  url: string;
}

export enum SoundChannels {
  STUDIO = 'studio',
  GAME = 'game',
  VOICEOVER = 'voiceover',
  BACKGROUND_MUSIC = 'backgroundMusic',
}
